import { ComponentType } from "react";
import LandingDynamic from "../pages/LandingDynamic";
import { ChatLayout } from "../pages/LandingSapphicChat";
import { DocLayout } from "../pages/LandingDocument";
import LandingReservation, { RESERVATION_EXAMPLE } from "./LandingReservation";
import LandingReceipt, { RECEIPT_EXAMPLE } from "./LandingReceipt";
import LandingLongform, {
  LONGFORM_MEN,
  LONGFORM_MEN_50P,
  LONGFORM_SAPPHIC,
  LONGFORM_SAPPHIC_50P,
} from "./LandingLongform";
import { useVariantLanguage } from "./shared";
import LandingSapphicChat from "../pages/LandingSapphicChat";
import { DocCeaseDesist } from "../pages/LandingDocument";

/**
 * Landing template registry.
 *
 * A landing variant (landing_variants.config, created via the ops MCP) picks
 * its layout with `config.template`; omitted/unknown templates fall back to
 * the classic LandingDynamic. Adding a template = one component + one entry
 * here + one deploy; after that, every variant of it ships via MCP with no
 * deploy. See docs/landing-templates.md for each template's config schema.
 */

export const LANDING_TEMPLATES: Record<string, ComponentType<{ config: any }>> = {
  chat: ChatLayout,
  document: DocLayout,
  reservation: LandingReservation,
  receipt: LandingReceipt,
  longform: LandingLongform,
};

export function TemplatePage({ config, language }: { config: any; language?: string }) {
  const Template = config?.template ? LANDING_TEMPLATES[config.template] : undefined;
  // LandingDynamic pins the language itself; templates get it from here, so a
  // new template cannot forget to. Hook order is stable because the branch
  // below only chooses which component renders, never whether the hook runs.
  useVariantLanguage(Template ? language : undefined);
  if (Template) return <Template config={config} />;
  return <LandingDynamic config={config} language={language ?? "en"} />;
}

/** /tpl/:template — live previews of each template's example config (QA aid). */
export const TEMPLATE_PREVIEWS: Record<string, ComponentType> = {
  chat: LandingSapphicChat,
  document: DocCeaseDesist,
  reservation: () => <LandingReservation config={RESERVATION_EXAMPLE} />,
  receipt: () => <LandingReceipt config={RECEIPT_EXAMPLE} />,
  longform: () => <LandingLongform config={LONGFORM_MEN} />,
  // Audience previews. `config.template` stays "longform" for all four; these
  // exist so each segment can be QA'd before a variant ships.
  "longform-men": () => <LandingLongform config={LONGFORM_MEN} />,
  "longform-men50": () => <LandingLongform config={LONGFORM_MEN_50P} />,
  "longform-sapphic": () => <LandingLongform config={LONGFORM_SAPPHIC} />,
  "longform-sapphic50": () => <LandingLongform config={LONGFORM_SAPPHIC_50P} />,
};
